import { CellEntityType } from 'services/ArtboardConverter/constants';
import { Schemas } from 'services/ArtboardConverter/models';

export const createSpacer = ({
  height = '0',
} = {} as Partial<Schemas.Spacer>): Schemas.Spacer => ({
  height,
  entityType: CellEntityType.SPACER,
});
